import { useEffect } from "react";
import { FAQS } from "@/data/content";

/**
 * Injects Schema.org FAQPage structured data into <head> so
 * Google + AI answer engines can quote answers directly.
 */
export default function FAQStructuredData() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "ccp-faq-jsonld";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: f.a,
        },
      })),
    });
    // avoid duplicates on HMR
    const existing = document.getElementById("ccp-faq-jsonld");
    if (existing) existing.remove();
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("ccp-faq-jsonld");
      if (el) el.remove();
    };
  }, []);
  return null;
}
